import { ChangeDetectionStrategy, Component, Input, Type } from '@angular/core';
import { ImageNode, Node, NodeType, PlainTextNode, TitleNode } from 'src/app/dto';
import { ImageNodeComponent } from '../image-node/image-node.component';
import { PlainTextNodeComponent } from '../plain-text-node/plain-text-node.component';
import { TaskProgressNodeComponent } from '../task-progress-node/task-progress-node.component';
import { TitleNodeComponent } from '../title-node/title-node.component';
import { UnknownNodeComponent } from '../unknown-node/unknown-node.component';

const NODE_COMPONENT_REGISTRY: Record<NodeType, Type<unknown>> = {
    [NodeType.PlainText]: PlainTextNodeComponent,
    [NodeType.Title]: TitleNodeComponent,
    [NodeType.Image]: ImageNodeComponent,
    [NodeType.TaskProgress]: TaskProgressNodeComponent,
};

@Component({
    selector: 'app-node-renderer',
    templateUrl: './node-renderer.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeRendererComponent {
    @Input() node: Node;

    get component(): Type<unknown> {
        return NODE_COMPONENT_REGISTRY[this.node?.NodeType] ?? UnknownNodeComponent;
    }

    get inputs(): Record<string, unknown> {
        return { node: this.node };
    }
}
